import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=3de55d86&scoped=true"
import script from "./ProfilePopup.vue?vue&type=script&lang=ts"
export * from "./ProfilePopup.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=3de55d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de55d86",
  null
  
)

export default component.exports